(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2960],{

/***/ 83973:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[category]/[connection_id]/[article_slug]",
      function () {
        return __webpack_require__(32897);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);

var ArticleNewImageModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, imageSrc = param.imageSrc;
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50",
        onClick: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container relative w-full p-4 pt-10 bg-white rounded-lg shadow-lg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "absolute z-50 text-2xl top-2 right-2",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "text-4xl font-bold ri-close-line"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: imageSrc,
                        className: "max-h-[90vh] w-full mt-2",
                        alt: "Selected"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleNewImageModal);


/***/ }),

/***/ 92832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13786);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63498);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50959);





var CategoryList = function(param) {
    var allCategories = param.allCategories;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "blog"
    ]).t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showCategories = ref[0], setShowCategories = ref[1];
    var isFullSlug = allCategories.some(function(category) {
        var ref;
        return category === null || category === void 0 ? void 0 : (ref = category.slug) === null || ref === void 0 ? void 0 : ref.startsWith("/blog");
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-3 mx-2 mt-8 bg-white rounded-lg lg:p-6 lg:my-0 lg:mx-0",
        children: [
            allCategories.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                className: "flex justify-between text-xl font-semibold",
                onClick: function() {
                    return setShowCategories(!showCategories);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center space-x-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "text-2xl lg:hidden ri-price-tag-3-fill"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    " ",
                                    t("blog:categories")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "ri-arrow-".concat(showCategories ? "up" : "down", "-s-line duration-500 lg:hidden")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:block ".concat(showCategories ? "block" : "hidden"),
                children: allCategories.slice(0, 10).map(function(category, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: isFullSlug ? "".concat(category === null || category === void 0 ? void 0 : category.slug) : "/".concat(router.locale, "/blog/").concat(category === null || category === void 0 ? void 0 : category.slug),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between py-4  cursor-pointer border-buttonBg ".concat(index === allCategories.length - 1 ? "" : "border-b lg:border-b-2"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm font-medium text-textGray",
                                    children: category === null || category === void 0 ? void 0 : category.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "flex justify-center items-center p-4 w-6 h-6 text-black rounded-full lg:text-textGray bg-buttonBg lg:bg-makdosYellow",
                                    children: category === null || category === void 0 ? void 0 : category.article_count
                                })
                            ]
                        })
                    }, index);
                })
            }),
            allCategories.length > 10 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-4 mt-5 w-full rounded-full cursor-pointer text-textGray bg-buttonBg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "flex justify-center items-center",
                    children: [
                        " ",
                        t("blog:allCategories")
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryList);


/***/ }),

/***/ 79907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13786);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63498);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);




var MostReadArticle = function(param) {
    var mostReadArticles = param.mostReadArticles;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "blog"
    ]).t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isFullSlug = mostReadArticles.status !== "records_not_found" ? mostReadArticles.some(function(article) {
        var ref;
        return article === null || article === void 0 ? void 0 : (ref = article.slug) === null || ref === void 0 ? void 0 : ref.startsWith("/blog");
    }) : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: "text-xl font-semibold",
                children: t("blog:mostReadArticle")
            }),
            mostReadArticles && mostReadArticles.length > 0 ? mostReadArticles.map(function(article, index) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: isFullSlug ? "".concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug) : "/".concat(router.locale, "/blog/").concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center p-3 space-x-3 cursor-pointer ".concat(index !== mostReadArticles.length - 1 ? "border-b-2 border-buttonBg" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "flex justify-center items-center p-4 w-6 h-6 text-black rounded-full bg-makdosYellow",
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "font-medium text-textGray",
                                children: article === null || article === void 0 ? void 0 : article.title
                            })
                        ]
                    })
                }, index);
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-4 text-center text-gray-500",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: t("blog:noMostReadArticles", "En \xe7ok okunan makale bulunamadı.")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MostReadArticle);


/***/ }),

/***/ 68593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);


var SocialMediaContent = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "blog"
    ]).t;
    var socialMedia = [
        {
            id: 1,
            icon: "ri-instagram-line",
            link: "https://www.instagram.com/makdos.cloud/",
            name: "makdos.cloud"
        },
        {
            id: 2,
            icon: "ri-facebook-circle-line",
            link: "https://www.facebook.com/makdostech",
            name: "makdos"
        },
        {
            id: 3,
            icon: "ri-linkedin-line",
            link: "https://tr.linkedin.com/company/makdos",
            name: "makdos"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "hidden p-6 bg-white rounded-md lg:block",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: "pb-4 text-2xl font-semibold",
                children: t("blog:socialMedia")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-textGray",
                children: t("blog:followSocialMedia")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pt-5",
                children: socialMedia.map(function(media, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center justify-between pb-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "text-2xl text-black ".concat(media.icon)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: media.link,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-textGray",
                                        children: media.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-textGray px-4 py-2.5 rounded-full border-2 border-buttonBg cursor-pointer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: media.link,
                                    target: "_blank",
                                    children: t("blog:follow")
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialMediaContent);


/***/ }),

/***/ 2097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2218);



function SSSAccordion(param) {
    var title = param.title, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "faqAccordionColspan",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full p-3 border-2 ".concat(open ? "rounded-b-none border-b" : "rounded-md"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    onClick: function() {
                        return setOpen(!open);
                    },
                    className: "faqTitleStyle",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "font-semibold text-md",
                            children: title
                        }),
                        !open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "text-xl font-semibold ri-add-line"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "text-xl font-semibold ri-subtract-line"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "faqChildrenStyle ".concat(open ? "block" : "hidden", " "),
                children: children
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SSSAccordion);


/***/ }),

/***/ 32897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(59072);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _components_Blog_CategoryList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92832);
/* harmony import */ var _components_Blog_MostReadArticle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79907);
/* harmony import */ var _components_Blog_SocialMediaContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68593);
/* harmony import */ var layout_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4967);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93834);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70649);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63498);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98777);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66264);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50959);
/* harmony import */ var _components_Toast_AllToast__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86749);
/* harmony import */ var copy_to_clipboard__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(874);
/* harmony import */ var copy_to_clipboard__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var store_GlobalStore__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36345);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13786);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _components_Blog_ArticleNewImageModal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41913);
/* harmony import */ var _components_SSS_SSSAccordion__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2097);


















var articleDetail = function(param) {
    var mostReadArticles = param.mostReadArticles, allCategories = param.allCategories, articleDetail = param.articleDetail, homeHighlights = param.homeHighlights;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
    var defaultNoImage = "/noImageWiki.png";
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)([
        "blog"
    ]).t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref27 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]), heading = ref27[0], setHeading = ref27[1];
    var ref28 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false), copied = ref28[0], setCopied = ref28[1];
    var ref29 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,store_GlobalStore__WEBPACK_IMPORTED_MODULE_13__/* .useGlobalStore */ .s)(function(state) {
        return [
            state.setOtherArticles
        ];
    }), 1), setOtherArticles = ref29[0];
    var languageID = router.locale === "tr" ? 1 : 2;
    var articleData = articleDetail === null || articleDetail === void 0 ? void 0 : (ref = articleDetail.article_detail_list) === null || ref === void 0 ? void 0 : ref.find(function(article) {
        return (article === null || article === void 0 ? void 0 : article.language_id) === languageID;
    });
    var articleRef = (0,react__WEBPACK_IMPORTED_MODULE_10__.useRef)(null);
    var isFullSlug = (articleData === null || articleData === void 0 ? void 0 : articleData.slug.startsWith("/blog/tr")) || (articleData === null || articleData === void 0 ? void 0 : articleData.slug.startsWith("/blog/en"));
    var ref30 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(0), currentHighlightIndex = ref30[0], setCurrentHighlightIndex = ref30[1];
    var ref31 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false), openImageModal = ref31[0], setOpenImageModal = ref31[1];
    var currentHighlight = homeHighlights[currentHighlightIndex];
    var handleShare = function(platform, slug) {
        var currentUrl = window.location;
        var baseUrl = "".concat(currentUrl.protocol, "//").concat(currentUrl.host);
        var newUrl = "".concat(baseUrl, "/").concat(slug);
        if (platform === "twitter") {
            window.open("https://twitter.com/intent/tweet?url=".concat(newUrl), "_blank");
        } else if (platform === "facebook") {
            window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(newUrl), "_blank");
        } else if (platform === "whatsapp") {
            window.open("https://wa.me/?text=".concat(encodeURIComponent(newUrl)), "_blank");
        } else if (platform === "telegram") {
            window.open("https://t.me/share/url?url=".concat(encodeURIComponent(newUrl), "&text=").concat(encodeURIComponent("Bu i\xe7eriğe g\xf6z at!")), "_blank");
        }
    };
    var handleCopyLink = function(slug) {
        var currentUrl = window.location;
        var baseUrl = "".concat(currentUrl.protocol, "//").concat(currentUrl.host);
        var newUrl = "".concat(baseUrl, "/").concat(slug);
        var isCopied = copy_to_clipboard__WEBPACK_IMPORTED_MODULE_12___default()(newUrl);
        if (isCopied) {
            setCopied(true);
            (0,_components_Toast_AllToast__WEBPACK_IMPORTED_MODULE_11__/* .successToast */ .Qm)("Link kopyalandı!", "Link kopyalandı.");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        if (articleRef.current) {
            var emptyParagraphs = articleRef.current.querySelectorAll("p:empty");
            emptyParagraphs.forEach(function(p) {
                p.style.display = "block";
                p.style.height = "16px";
                p.style.margin = "8px 0";
            });
            var titleStyle = articleRef.current.querySelectorAll("h3");
            titleStyle.forEach(function(h3) {
                h3.style.fontWeight = "bold";
                h3.style.fontSize = "20px";
            });
            var titleH2Style = articleRef.current.querySelectorAll("h2");
            titleH2Style.forEach(function(h2) {
                h2.style.fontWeight = "bold";
                h2.style.fontSize = "30px";
            });
            var paragraphStyle = articleRef.current.querySelectorAll("p");
            paragraphStyle.forEach(function(p) {
                var spanStyle = p.querySelectorAll("span");
                var foundColoredSpan = false;
                var usedBgColor = "";
                spanStyle.forEach(function(span) {
                    var bgColor = window.getComputedStyle(span).backgroundColor;
                    if (bgColor !== "rgb(255, 255, 255)" && bgColor !== "rgba(0, 0, 0, 0)" && bgColor !== "transparent") {
                        foundColoredSpan = true;
                        usedBgColor = bgColor;
                        span.style.color = "white";
                    }
                });
                if (foundColoredSpan) {
                    var wrapperDiv = document.createElement("div");
                    wrapperDiv.style.width = "100%";
                    wrapperDiv.style.display = "flex";
                    wrapperDiv.style.flexDirection = "column";
                    wrapperDiv.style.alignItems = "center";
                    wrapperDiv.style.justifyContent = "center";
                    wrapperDiv.style.textAlign = "center";
                    wrapperDiv.style.paddingTop = "16px";
                    wrapperDiv.style.paddingBottom = "16px";
                    wrapperDiv.style.paddingLeft = "30px";
                    wrapperDiv.style.paddingRight = "30px";
                    wrapperDiv.style.marginBottom = "8px";
                    wrapperDiv.style.backgroundColor = usedBgColor;
                    wrapperDiv.style.color = "white";
                    wrapperDiv.style.borderRadius = "4px";
                    wrapperDiv.style.lineHeight = "1.4";
                    p.style.margin = "0";
                    p.style.textAlign = "center";
                    p.parentNode.insertBefore(wrapperDiv, p);
                    wrapperDiv.appendChild(p);
                }
            });
            var liItems = articleRef.current.querySelectorAll("li");
            liItems.forEach(function(li) {
                // En yakın UL veya OL öğesini bul
                var list = li.closest("ul, ol");
                if (!list) return;
                var text = li.textContent.trim();
                if (list.tagName === "UL") {
                    // UL içindeyse, başında ・ yoksa ekle
                    if (!text.startsWith("・")) {
                        li.innerHTML = '<span class="big-bullet">・</span> '.concat(text);
                    }
                } else if (list.tagName === "OL") {
                    // OL içindeyse, başında "1. " gibi yoksa index'e göre ekle
                    // parentElement.children OL içindeki tüm LI'ları verir
                    var siblings = Array.from(list.children).filter(function(el) {
                        return el.tagName === "LI";
                    });
                    var idx = siblings.indexOf(li);
                    // regex ile zaten “1. “ benzeri varsa tekrar eklemesini engelle
                    if (!/^\d+\.\s+/.test(text) && idx !== -1) {
                        li.innerHTML = '<span class="big-number">'.concat(idx + 1, ".</span> ").concat(text);
                    }
                }
            });
            var linkItems = articleRef.current.querySelectorAll("a");
            linkItems.forEach(function(a) {
                a.style.color = "#1d4ed8";
                a.style.textDecoration = "none";
                a.style.transition = "all 0.2s ease";
                a.setAttribute("target", "_blank");
                a.setAttribute("rel", "noopener noreferrer");
                a.addEventListener("mouseenter", function() {
                    a.style.textDecoration = "underline";
                });
                a.addEventListener("mouseleave", function() {
                    a.style.textDecoration = "none";
                });
            });
            var contentsHeading = Array.from(titleH2Style).map(function(title, index) {
                return {
                    id: "heading-".concat(index),
                    title: title.textContent,
                    element: title
                };
            });
            contentsHeading.forEach(function(heading) {
                heading.element.id = heading.id;
            });
            var images = articleRef.current.querySelectorAll("img");
            images.forEach(function(img) {
                img.style.cursor = "pointer";
                img.onclick = function() {
                    setOpenImageModal(img.src);
                };
            });
            setHeading(contentsHeading);
        }
    }, [
        articleData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        var otherArticleData = articleDetail.article_detail_list.find(function(article) {
            return article.language_id !== languageID;
        }) ? [
            articleDetail.article_detail_list.find(function(article) {
                return article.language_id !== languageID;
            })
        ] : [];
        setOtherArticles(otherArticleData);
    }, [
        articleDetail
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        if ((homeHighlights === null || homeHighlights === void 0 ? void 0 : homeHighlights.length) > 0) {
            var interval = setInterval(function() {
                setCurrentHighlightIndex(function(prevIndex) {
                    return (prevIndex + 1) % homeHighlights.length;
                });
            }, 60000); // 60 saniye
            return function() {
                return clearInterval(interval);
            };
        }
    }, [
        homeHighlights
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(layout_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: articleData === null || articleData === void 0 ? void 0 : articleData.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: articleData === null || articleData === void 0 ? void 0 : articleData.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: articleData === null || articleData === void 0 ? void 0 : articleData.title
                    }, "title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: articleData === null || articleData === void 0 ? void 0 : articleData.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: (articleData === null || articleData === void 0 ? void 0 : articleData.image) ? "https://api-web.makdos.com/" + (articleData === null || articleData === void 0 ? void 0 : articleData.image) : "https://makdos.com/headerLogo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full bg-slate-100 lg:bg-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[228px] lg:!h-[264px] items-center justify-center flex bg-makdosYellow "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container z-30 mx-auto -mt-40 lg:-mt-72 lg:py-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid lg:gap-6 lg:grid-cols-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-span-1 lg:mx-0 lg:col-span-9",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-4 bg-white rounded-md lg:p-7",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "relative w-full h-[211px] lg:h-[429px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                    src: (articleData === null || articleData === void 0 ? void 0 : articleData.image) ? "https://api-web.makdos.com/" + (articleData === null || articleData === void 0 ? void 0 : articleData.image) : "/dummyhighlight.svg",
                                                    layout: "fill",
                                                    alt: articleData === null || articleData === void 0 ? void 0 : articleData.title,
                                                    title: articleData === null || articleData === void 0 ? void 0 : articleData.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    className: "pt-4 text-4xl font-semibold text-black",
                                                    children: articleData === null || articleData === void 0 ? void 0 : articleData.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col pt-4 lg:space-x-4 lg:items-center lg:flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                                        href: isFullSlug ? "".concat(articleData === null || articleData === void 0 ? void 0 : articleData.category_slug) : "/blog/".concat(articleData === null || articleData === void 0 ? void 0 : articleData.category_slug),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex justify-center items-center p-2 space-x-2 text-sm rounded-full cursor-pointer w-fit text-textGray bg-buttonBg",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "w-3 h-3 rounded-full bg-makdosYellow"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: (articleData === null || articleData === void 0 ? void 0 : articleData.category_title.length) > 30 ? (articleData === null || articleData === void 0 ? void 0 : articleData.category_title.substring(0, 30)) + "..." : articleData === null || articleData === void 0 ? void 0 : articleData.category_title
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex items-center space-x-1 font-medium text-slate-400",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "text-base ri-calendar-2-line"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-sm",
                                                                children: moment__WEBPACK_IMPORTED_MODULE_8___default()(articleData === null || articleData === void 0 ? void 0 : articleData.create_time).format("DD.MM.YYYY HH:mm")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex items-center space-x-1 font-medium text-slate-400",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "text-base ri-user-line"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-sm",
                                                                children: (articleData === null || articleData === void 0 ? void 0 : articleData.created_by) ? articleData === null || articleData === void 0 ? void 0 : articleData.created_by : "Makdos"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex items-center space-x-1 font-medium text-slate-400",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "text-base ri-time-line"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-sm",
                                                                children: (articleData === null || articleData === void 0 ? void 0 : articleData.read_time) + " " + t("blog:minReading")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex justify-between items-center py-6 mt-4 border-y border-buttonBg",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "hidden font-medium text-slate-400 lg:block",
                                                        children: t("blog:shareOnSocialMedia")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "space-x-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "p-2 text-2xl rounded-full border cursor-pointer border-buttonBg ri-twitter-x-fill",
                                                                    onClick: function() {
                                                                        return handleShare("twitter", "blog/".concat(router.locale, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.category_slug, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.connection_id, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.slug));
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "p-2 text-2xl rounded-full border cursor-pointer ri-facebook-circle-fill border-buttonBg",
                                                                    onClick: function() {
                                                                        return handleShare("facebook", "blog/".concat(router.locale, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.category_slug, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.connection_id, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.slug));
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "p-2 text-2xl rounded-full border cursor-pointer border-buttonBg ri-whatsapp-fill",
                                                                    onClick: function() {
                                                                        return handleShare("whatsapp", "blog/".concat(router.locale, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.category_slug, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.connection_id, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.slug));
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "p-2 text-2xl rounded-full border cursor-pointer border-buttonBg ri-telegram-fill",
                                                                    onClick: function() {
                                                                        return handleShare("telegram", "blog/".concat(router.locale, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.category_slug, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.connection_id, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.slug));
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "p-2 text-2xl rounded-full border cursor-pointer border-buttonBg ri-share-forward-fill",
                                                                    onClick: function() {
                                                                        return handleCopyLink("blog/".concat(router.locale, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.category_slug, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.connection_id, "/").concat(articleData === null || articleData === void 0 ? void 0 : articleData.slug));
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            (articleData === null || articleData === void 0 ? void 0 : articleData.video_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "relative w-full h-[211px] lg:h-[429px]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                                        width: "100%",
                                                        height: "100%",
                                                        src: articleData.video_url.replace("watch?v=", "embed/"),
                                                        title: "YouTube video player",
                                                        frameBorder: "0",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                                        allowFullScreen: true,
                                                        className: "rounded-md"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pt-4 font-bold text-black",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: articleData === null || articleData === void 0 ? void 0 : articleData.description
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pt-4 whitespace-pre-wrap article-content",
                                                ref: articleRef,
                                                dangerouslySetInnerHTML: {
                                                    __html: articleData === null || articleData === void 0 ? void 0 : (ref1 = articleData.message) === null || ref1 === void 0 ? void 0 : ref1.replace(/\\n/g, "")
                                                }
                                            }),
                                            (articleData === null || articleData === void 0 ? void 0 : articleData.similar_articles) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "py-8",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        className: "pb-2 text-xl font-bold",
                                                        children: t("blog:similarArticles")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: articleData === null || articleData === void 0 ? void 0 : articleData.similar_articles.map(function(article, index) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                                                href: article.link,
                                                                target: "blank",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "font-semibold cursor-pointer",
                                                                        children: article.title
                                                                    })
                                                                })
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "hidden lg:block lg:space-y-6 lg:order-none lg:col-span-3",
                                    children: [
                                        heading && heading.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "p-6 bg-white rounded-lg",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    className: "flex justify-between text-xl font-semibold",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        children: [
                                                            " ",
                                                            t("blog:contents")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: "mt-4 space-y-2",
                                                    children: heading.map(function(head) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            className: "py-4 border-b border-buttonBg",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "#".concat(head.id),
                                                                className: "text-textGray",
                                                                onClick: function(e) {
                                                                    e.preventDefault();
                                                                    var element = document.getElementById(head.id);
                                                                    if (element) {
                                                                        var offset = 105;
                                                                        var elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                                                        var offsetPosition = elementPosition - offset;
                                                                        window.scrollTo({
                                                                            top: offsetPosition,
                                                                            behavior: "smooth"
                                                                        });
                                                                    }
                                                                },
                                                                children: head.title
                                                            })
                                                        }, head.id);
                                                    })
                                                })
                                            ]
                                        }),
                                        currentHighlight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "p-3 bg-white rounded-md cursor-pointer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                                href: (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref2 = currentHighlight.content) === null || ref2 === void 0 ? void 0 : ref2.link) ? currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref3 = currentHighlight.content) === null || ref3 === void 0 ? void 0 : ref3.link : "",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "absolute z-10 object-cover\n                                             ".concat((currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref4 = currentHighlight.content) === null || ref4 === void 0 ? void 0 : ref4.template) === 1 ? "top-52 left-16" : "", "\n                                             ").concat((currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref5 = currentHighlight.content) === null || ref5 === void 0 ? void 0 : ref5.template) === 2 ? "top-24 left-16" : "", "\n                                            "),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                                src: (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref6 = currentHighlight.content) === null || ref6 === void 0 ? void 0 : ref6.image) ? "https://api-web.makdos.com/" + (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref7 = currentHighlight.content) === null || ref7 === void 0 ? void 0 : ref7.image) : "/defaultHighlight.png",
                                                                width: 200,
                                                                height: 200,
                                                                alt: (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref8 = currentHighlight.content) === null || ref8 === void 0 ? void 0 : ref8.image_alt_text) ? currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref9 = currentHighlight.content) === null || ref9 === void 0 ? void 0 : ref9.image_alt_text : "",
                                                                title: (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref10 = currentHighlight.content) === null || ref10 === void 0 ? void 0 : ref10.image_title) ? currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref11 = currentHighlight.content) === null || ref11 === void 0 ? void 0 : ref11.image_title : "",
                                                                onError: function(param) {
                                                                    var currentTarget = param.currentTarget;
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = defaultNoImage;
                                                                    currentTarget.srcset = defaultNoImage;
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                            className: "absolute font-bold z-10 text-sm px-4 py-2 text-center grid place-items-center w-full h-[20px]\n                                             ".concat((currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref12 = currentHighlight.content) === null || ref12 === void 0 ? void 0 : ref12.template) === 2 ? "bottom-40" : "", "\n                                            "),
                                                            children: currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref13 = currentHighlight.content) === null || ref13 === void 0 ? void 0 : ref13.image_title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "absolute z-10 text-[8px] px-4 py-4 text-center grid place-items-center w-full h-[20px]\n                                            ".concat((currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref14 = currentHighlight.content) === null || ref14 === void 0 ? void 0 : ref14.template) === 1 ? "top-10" : "", "\n                                            ").concat((currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref15 = currentHighlight.content) === null || ref15 === void 0 ? void 0 : ref15.template) === 2 ? "bottom-28" : "", "\n                                            "),
                                                            children: currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref16 = currentHighlight.content) === null || ref16 === void 0 ? void 0 : ref16.image_alt_text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "absolute z-10 font-bold text-xs text-white grid place-items-center text-center w-full h-[20px]\n                                            ".concat((currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref17 = currentHighlight.content) === null || ref17 === void 0 ? void 0 : ref17.template) === 1 ? "top-[119px]" : "", "\n                                             ").concat((currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref18 = currentHighlight.content) === null || ref18 === void 0 ? void 0 : ref18.template) === 2 ? "bottom-10" : "", "\n                                            "),
                                                            children: currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref19 = currentHighlight.content) === null || ref19 === void 0 ? void 0 : ref19.button_text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                            src: (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref20 = currentHighlight.content) === null || ref20 === void 0 ? void 0 : ref20.template_path) ? "https://api-web.makdos.com/" + (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref21 = currentHighlight.content) === null || ref21 === void 0 ? void 0 : ref21.template_path) : "/defaultHighlight.png",
                                                            width: 400,
                                                            height: 718,
                                                            alt: (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref22 = currentHighlight.content) === null || ref22 === void 0 ? void 0 : ref22.image_alt_text) ? currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref23 = currentHighlight.content) === null || ref23 === void 0 ? void 0 : ref23.image_alt_text : "",
                                                            title: (currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref24 = currentHighlight.content) === null || ref24 === void 0 ? void 0 : ref24.image_title) ? currentHighlight === null || currentHighlight === void 0 ? void 0 : (ref25 = currentHighlight.content) === null || ref25 === void 0 ? void 0 : ref25.image_title : "",
                                                            onError: function(param) {
                                                                var currentTarget = param.currentTarget;
                                                                currentTarget.onerror = null;
                                                                currentTarget.src = defaultNoImage;
                                                                currentTarget.srcset = defaultNoImage;
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "p-4 bg-white rounded-md",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_MostReadArticle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                mostReadArticles: mostReadArticles
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_CategoryList__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            allCategories: allCategories
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_SocialMediaContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            openImageModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_ArticleNewImageModal__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                isOpen: openImageModal,
                onClose: function() {
                    return setOpenImageModal(false);
                },
                imageSrc: openImageModal
            }),
            (articleData === null || articleData === void 0 ? void 0 : (ref26 = articleData.faq) === null || ref26 === void 0 ? void 0 : ref26.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "container px-4 mx-auto bg-white lg:px-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "relative z-30 text-4xl font-semibold text-after-shadow lg:text-5xl",
                            children: t("common:frequentlyAskedQuestions")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-2 mt-10 lg:gap-x-8",
                            children: articleData === null || articleData === void 0 ? void 0 : articleData.faq.map(function(faq, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SSS_SSSAccordion__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    title: faq.question,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: faq.answer
                                        }
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (articleDetail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2658,4967,9774,2888,179], function() { return __webpack_exec__(83973); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);